import React, { useState, useEffect } from "react";
import Main from "./Main";


function App(props) {
  return (
    <>
      <Main/>
    </>
  );
}

export default App;
